import {
  PayOverTimeListStatementsResultTypenames,
  Query,
} from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import PayOverTimeStatements from 'services/graphql/queries/PayOverTimeStatements';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { useFormattedCombinedError } from 'shared/hooks/errorFormatters/useFormattedCombinedError/useFormattedCombinedError';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { RequestPolicy, useQuery } from 'urql';

const usePayOverTimeLoanStatements = (
  requestPolicy: RequestPolicy = 'cache-and-network',
  pause = false,
) => {
  const router = useRouter();
  const [{ data, fetching: loading, error }, refetchPayOverTimeStatements] =
    useQuery<Query>({
      pause,
      query: PayOverTimeStatements,
      requestPolicy,
    });

  const result = data?.payOverTimeStatements;
  const statements =
    result?.__typename ===
    PayOverTimeListStatementsResultTypenames.PayOverTimeListStatementsSuccess
      ? result.statements
      : [];
  const resultError =
    result?.__typename ===
    PayOverTimeListStatementsResultTypenames.PayOverTimeListStatementsError
      ? result
      : null;

  const refresh = () => {
    refetchPayOverTimeStatements({ requestPolicy: 'network-only' });
  };

  const cancel = () => {
    router.back();
  };

  const { defaultTitle, defaultMessage, retryButtonTitle, cancelButtonTitle } =
    useDefaultErrorStrings();
  const responseError = useFormattedCombinedError(error);

  const errorModel =
    error || resultError
      ? {
          screenType: ErrorScreenType.Error,
          messageHeadline:
            resultError?.title ?? responseError?.title ?? defaultTitle,
          messageBody:
            resultError?.message ?? responseError?.message ?? defaultMessage,
          primaryButton: {
            title: retryButtonTitle,
            onPress: refresh,
          },
          secondaryButton: {
            title: cancelButtonTitle,
            onPress: cancel,
          },
        }
      : null;

  return {
    statements,
    errorModel,
    loading,
    refresh,
  };
};

export default usePayOverTimeLoanStatements;
